document.addEventListener("DOMContentLoaded", function() {
  const openFormButtons = document.querySelectorAll('.js-open-form');

  openFormButtons.forEach(function(openFormButton) {
    const section = openFormButton.closest('.wp-block-lb-cta-whitepaper');

    if (!section) {
      return;
    }

    const formWrapper = section.querySelector('.form-wrapper');
    const sectionColumns = section.querySelector('.section-columns');
    const formColumnContent = section.querySelector('.form-column--content');

    if (formWrapper) {
      formWrapper.style.display = 'none';
    }

    openFormButton.addEventListener('click', function() {
      if (formWrapper) {
        formWrapper.style.display = 'block';
        formWrapper.classList.add('visible');
      }

      if (sectionColumns) {
        sectionColumns.classList.add('hide');
      }
    });

    const observer = new MutationObserver(function(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const successAlert = section.querySelector('.gform_confirmation_message');
          if (successAlert) {
            if (formColumnContent) {
              formColumnContent.style.display = 'none';
            }

            const brs = successAlert.querySelectorAll('br');
            brs.forEach(br => br.remove());
          }
        }
      }
    });

    observer.observe(section, { childList: true, subtree: true });
  });
});
